import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalMultiSelect, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useRiskScenarioDialogDataMapping } from "./RiskScenarioDialog.hooks";
import { RiskScenarioSaveModel } from "./RiskScenarioDialog.types";
import DialogHeaderWithInformation from "@common/components/dialogHeaderWithInformation/DialogHeaderWithInformation";

export interface IRiskScenarioDialog {
    onCloseDialog: () => void;
    onSave: () => void;
    selectedRiskScenario?: RiskScenarioSaveModel;
}

function RiskScenarioDialog(props: IRiskScenarioDialog) {
    const { translateString } = useTranslation();
    const {
        viewModel,
        validation,
        inProgress,
        isEdit,
        setName,
        setDescription,
        setCategory,
        setRiskAreas,
        chosenRiskAreas,
        setEntityTypes,
        chosenEntityTypes,
        entityTypeOptions,
        validateAndSave,
        categoryOptions,
        riskAreasLoading,
        riskAreaOptions,
    } = useRiskScenarioDialogDataMapping(props);

    return (
        <DotLegalDialog
            inProgress={inProgress}
            size="sm"
            buttonOkText={isEdit() ? translateString("save") : translateString("create")}
            header={
                <DialogHeaderWithInformation
                    header={isEdit() ? translateString("editRiskScenario") : translateString("createRiskScenario")}
                    information={isEdit() ? undefined : translateString("riskScenarioNameTooltip")}
                />
            }
            onOkClick={validateAndSave}
            onDialogClose={props.onCloseDialog}
            open
            disableBackdropOnCloseIfValueChange={viewModel}
        >
            <Box sx={{ marginRight: 3 }}>
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    label={translateString("riskScenario")}
                    value={viewModel.name}
                    onChange={setName}
                    errorText={validation.getErrorsForDisplay("name")}
                    toolTipText={translateString("riskScenarioNameTooltip")}
                    multiline
                    rows={1}
                />
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    multiline
                    rows={4}
                    label={translateString("description")}
                    value={viewModel.description ?? ""}
                    onChange={setDescription}
                />
                <DotLegalSelect
                    label={translateString("category")}
                    options={categoryOptions}
                    selectedItem={viewModel.category}
                    onChange={setCategory}
                    errorText={validation.getErrorsForDisplay("category")}
                    noOptionsLabel={translateString("noOptions")}
                    toolTipText={translateString("riskScenarioCategoryTooltip")}
                />
                <DotLegalMultiSelect
                    label={translateString("riskAreas")}
                    options={riskAreaOptions}
                    chosenOptions={chosenRiskAreas}
                    onChange={setRiskAreas}
                    isLoading={riskAreasLoading}
                    noOptionsLabel={translateString("noOptions")}
                    errorText={validation.getErrorsForDisplay("riskAreas")}
                />
                <DotLegalMultiSelect
                    label={translateString("types")}
                    options={entityTypeOptions}
                    chosenOptions={chosenEntityTypes}
                    onChange={setEntityTypes}
                    noOptionsLabel={translateString("noOptions")}
                    errorText={validation.getErrorsForDisplay("entityTypes")}
                />
            </Box>
        </DotLegalDialog>
    );
}

export default RiskScenarioDialog;
